import produce from 'immer';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import MetadataForm from '~/components/metadata_form';
const AdvancedDocumentSearch = (props) => {
    const { advancedFilters, setAdvancedFilters } = props;
    const { orgMetadata: anyOrgMetadata } = useSelector((state) => state.orgMetadataState);
    const orgMetadata = anyOrgMetadata;
    const [isFoldOpen, setIsFoldOpen] = useState(false);
    const onFormChange = (name, value) => {
        setAdvancedFilters(Object.assign(Object.assign({}, advancedFilters), { [name]: value }));
    };
    if (orgMetadata === null) {
        return (React.createElement("div", { className: 'text-center' }, "Loading..."));
    }
    const includeExpired = !!(advancedFilters === null || advancedFilters === void 0 ? void 0 : advancedFilters.includeExpired);
    const metadata = [];
    for (const [name, value] of Object.entries(advancedFilters)) {
        metadata.push({ name, value });
    }
    const modifiedOrgMetadata = produce(orgMetadata, draft => {
        const formTypeIndex = draft.findIndex(orgMetaField => orgMetaField.name === 'Form Type');
        if (formTypeIndex !== -1)
            draft[formTypeIndex].isMulti = true;
        const formSourceIndex = draft.findIndex(orgMetaField => orgMetaField.name === 'Form Source');
        if (formSourceIndex !== -1)
            draft[formSourceIndex].isMulti = true;
    });
    const formStatusField = orgMetadata.find(orgMetaField => orgMetaField.name === 'Form Status');
    return (React.createElement("div", { className: 'advanced-document-search', "data-testid": 'advanced-document-search-dialog' },
        React.createElement(MetadataForm, { handleFormChange: onFormChange, orgMetadata: modifiedOrgMetadata, metadata: metadata, fieldsToRender: [
                'Lines of Business',
                'Form Type',
                'Form Number',
                'Form Title',
                'Effective Date',
            ], optionalFields: ['*'] }),
        React.createElement("small", { className: 'fold-trigger', onClick: () => setIsFoldOpen(!isFoldOpen) },
            isFoldOpen && React.createElement("span", null,
                React.createElement("i", { className: 'fa fa-filter' }),
                " Hide Filters"),
            !isFoldOpen && React.createElement("span", null,
                React.createElement("i", { className: 'fa fa-filter' }),
                " Show More Filters")),
        isFoldOpen &&
            React.createElement("div", { className: 'fold' },
                React.createElement(MetadataForm, { handleFormChange: onFormChange, orgMetadata: modifiedOrgMetadata, metadata: metadata, fieldsToRender: [
                        'Competitor',
                        'Business Unit',
                        'Jurisdiction',
                        'Admitted Or Not',
                        'Form Source',
                        'Form Edition Date',
                        'Interline Or Not',
                    ], optionalFields: ['*'] })),
        formStatusField &&
            React.createElement("div", { className: 'include-expired advanced-search-group' },
                React.createElement("div", { className: 'advanced-search-inputs' },
                    React.createElement("span", { className: 'input-container' },
                        React.createElement("input", { type: 'checkbox', id: 'include_expired', "data-testid": 'search-include-expired-input', checked: includeExpired, onChange: () => onFormChange('includeExpired', !includeExpired), className: 'input checkbox' }),
                        React.createElement("label", { className: 'input-label', htmlFor: 'include_expired' }, "Include Expired"))))));
};
export default AdvancedDocumentSearch;
